import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const EyeHideIconSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#fff",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.59 2.5a.75.75 0 00-1.06 1.06l3.355 3.356A11.887 11.887 0 001 12.03c1.73 4.39 6 7.5 11 7.5 1.624 0 3.17-.328 4.578-.921l2.892 2.89a.75.75 0 101.06-1.06L2.59 2.5zm11.801 13.922l-1.52-1.52a3.01 3.01 0 01-.871.128c-1.66 0-3-1.34-3-3 0-.303.045-.596.128-.872l-1.52-1.52a5.002 5.002 0 006.783 6.783z"
        fill={color}
      />
      <path
        d="M11.223 9.131l3.676 3.677c.066-.248.101-.509.101-.778a2.996 2.996 0 00-3.777-2.899z"
        fill={color}
      />
      <path
        d="M17 12.03c0 .834-.205 1.62-.566 2.313l2.75 2.75A11.887 11.887 0 0023 12.03c-1.73-4.39-6-7.5-11-7.5-1.591 0-3.108.315-4.493.886l2.18 2.18A5.002 5.002 0 0117 12.03z"
        fill={color}
      />
    </svg>
  );
};

export { EyeHideIconSvg };
